import { DeleteRequest, GetListRequest, GetListResponse } from "./api.model";

export type SubEventGetListRequest = GetListRequest<SubEventGetListRequestFilter>;
export type SubEventGetListResponse = GetListResponse<SubEvent>;
export type SubEventDeleteRequest = DeleteRequest;

export interface SubEventGetListRequestFilter {
  /** @format int64 */
  refOrganization_Id?: number | null;

  /** @format int64 */
  refEvent_Id?: number | null;
  code?: string | null;
  name?: string | null;

  /** @format date-time */
  startTime?: string | null;

  /** @format date-time */
  endTime?: string | null;

  /** @format date-time */
  bookingStartDateTime?: string | null;

  /** @format int32 */
  bookingEndDateTime?: number | null;

  /** @format int64 */
  refVenueDetails_Id?: number | null;
  status?: SubEventStatus;
  tags?: string | null;
  isEnabled?: boolean | null;

  /** @format int64 */
  sortOrder?: number | null;
}

export type SubEventStatus = 1 | 2 | 3;

export interface SubEvent {
  /** @format int64 */
  refOrganization_Id?: number | null;

  /** @format int64 */
  refEvent_Id?: number | null;
  code?: string | null;
  name?: string | null;

  /** @format date-time */
  startTime?: string | null;

  /** @format date-time */
  endTime?: string | null;

  /** @format date-time */
  bookingStartDateTime?: string | null;

  /** @format int32 */
  bookingEndDateTime?: number | null;

  /** @format int64 */
  refVenueDetails_Id?: number | null;
  status?: SubEventStatus;
  tags?: string | null;
  isEnabled?: boolean | null;

  /** @format int64 */
  sortOrder?: number | null;

  /** @format int64 */
  id?: number;

  /** @format byte */
  system_RowVersion?: string | null;
}

export interface SubEventTranslationInsertRequest {
  translation?: string | null;
  name?: string | null;
  description?: string | null;
  tags?: string | null;

  /** @format int64 */
  refLanguage_Id?: number | null;
  isEnabled?: boolean | null;
}

export interface SubEventInsertRequest {
  /** @format int64 */
  refOrganization_Id?: number | null;

  /** @format int64 */
  refEvent_Id?: number | null;
  code?: string | null;
  name?: string | null;

  /** @format date-time */
  startTime?: string | null;

  /** @format date-time */
  endTime?: string | null;

  /** @format date-time */
  bookingStartDateTime?: string | null;

  /** @format int32 */
  bookingEndDateTime?: number | null;

  /** @format int64 */
  refVenueDetails_Id?: number | null;
  status?: SubEventStatus;
  tags?: string | null;
  isEnabled?: boolean | null;

  /** @format int64 */
  sortOrder?: number | null;
  subEvent_Translations: SubEventTranslationInsertRequest[];
}
